// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__cxFGE","selected":"Chip_selected__28BAb"};